import React from 'react';
import { Step4Props } from './types';
import {
  MODAL_CONTENT,
  SUCCESS_CONTAINER,
  SUCCESS_ICON,
  SUCCESS_MESSAGE,
  SUCCESS_DESCRIPTION,
  SPARKLE_CTA,
  SPARKLE_CTA_NOTE,
  PRODUCT_INFO,
  PRODUCT_INFO_ITEM,
  PRODUCT_INFO_LABEL,
  PRODUCT_INFO_VALUE,
  BUTTON_GROUP,
  buttonClass,
} from './styles';

const Step4Complete: React.FC<Step4Props> = ({
  product,
  onViewProducts,
  onClose,
  freeBannerAvailable = false,
  onStartBanners,
  startingBanners = false,
}) => {
  const showSparkleCTA = freeBannerAvailable && Boolean(onStartBanners);

  return (
    <div className={MODAL_CONTENT}>
      <div className={SUCCESS_CONTAINER}>
        <div className={SUCCESS_ICON}>✓</div>
        <h3 className={SUCCESS_MESSAGE}>商品情報の登録が完了しました</h3>
        <p className={SUCCESS_DESCRIPTION}>
          戦略マップ・基本情報・ブランド・商品画像を生成しました。
        </p>

        {showSparkleCTA && (
          <div style={{ width: '100%' }}>
            <button
              className={SPARKLE_CTA}
              type="button"
              onClick={onStartBanners}
              disabled={startingBanners}
            >
              {startingBanners ? '準備しています...' : '✦ このまま無料でバナーを10枚作る'}
            </button>
            <p className={SPARKLE_CTA_NOTE}>初回限定・クレジット消費なしで10枚生成できます</p>
          </div>
        )}

        <div className={PRODUCT_INFO}>
          <div className={PRODUCT_INFO_ITEM}>
            <span className={PRODUCT_INFO_LABEL}>商品名</span>
            <span className={PRODUCT_INFO_VALUE}>{product?.name || '-'}</span>
          </div>

          {product?.url && (
            <div className={PRODUCT_INFO_ITEM}>
              <span className={PRODUCT_INFO_LABEL}>URL</span>
              <span className={PRODUCT_INFO_VALUE}>{product.url}</span>
            </div>
          )}
        </div>
      </div>

      {/* ButtonGroup は SuccessContainer(padding/align-items:center) の外に置き、
          Step1/3 と同じく ModalContent 直下の sticky フッターとして左右フルブリードで揃える。 */}
      <div className={BUTTON_GROUP}>
        <button className={buttonClass('outline')} type="button" onClick={onClose}>
          閉じる
        </button>
        <button className={buttonClass('primary')} type="button" onClick={onViewProducts}>
          商品情報を見る
        </button>
      </div>
    </div>
  );
};

export default Step4Complete;
